import * as React from 'react';
import { Icon } from '../Icon';
import { IIcon } from '../../interfaces/IIcon';

export function ListIcon(props: IIcon) {
    return (
        <Icon
            width={props.width}
            height={props.height}
            viewBox={props.viewBox}
            style={props.style}
            className={props.className}
        >
            <g>
                <g>
                    <circle cx="39.081" cy="54.785" r="39.081" />
                    <circle cx="39.081" cy="174.785" r="39.081" />
                    <circle cx="39.081" cy="294.785" r="39.081" />
                    <g>
                        <path
                            d="M344.569,20.535H113.581c-2.757,0-5,2.243-5,5v58.5c0,2.757,2.243,5,5,5h230.988c2.757,0,5-2.243,5-5v-58.5
				C349.569,22.778,347.326,20.535,344.569,20.535z"
                        />
                        <path
                            d="M344.569,140.535H113.581c-2.757,0-5,2.243-5,5v58.5c0,2.757,2.243,5,5,5h230.988c2.757,0,5-2.243,5-5v-58.5
				C349.569,142.778,347.326,140.535,344.569,140.535z"
                        />
                        <path
                            d="M344.569,260.535H113.581c-2.757,0-5,2.243-5,5v58.5c0,2.757,2.243,5,5,5h230.988c2.757,0,5-2.243,5-5v-58.5
				C349.569,262.778,347.326,260.535,344.569,260.535z"
                        />
                    </g>
                </g>
            </g>
        </Icon>
    );
}
